// product-page.js
// Loaded only on product pages via sections/main-product.liquid
// Handles: product image swap, mobile swiper, model sizing badge, variant tag

function handleProductImages(isQuickView) {
  const colorSwatches = document.querySelectorAll('.color-swatch-input:not([id*="product-recommendations"]):not([data-cross-sell-list] *)');
  const mediaItems = document.querySelectorAll('.product__media-item, .product__media-subitem');
  const modelSizeTextEl = document.querySelectorAll('.size_model-main .main-text-model');

  if (!colorSwatches.length || !mediaItems.length || !modelSizeTextEl) return;

  // Shop This Color — parse map once, reuse in updateMediaDisplay
  const _stcLink = document.querySelector('.ctm-shop-this-color-link');
  const _stcMap = {};
  if (_stcLink) {
    (_stcLink.getAttribute('data-color-map') || '').replace(/&#10;/g, '\n').split('\n').forEach(function(line) {
      line = line.trim();
      if (!line) return;
      const i = line.indexOf(':');
      if (i !== -1) _stcMap[line.slice(0, i).trim().toLowerCase()] = line.slice(i + 1).trim();
    });
  }

  updateVariantBadge();

  const paginationElTemp = document.querySelector('.product__media-list.swiper .swiper-pagination');
  const swiperEl = paginationElTemp ? paginationElTemp.closest('.product__media-list.swiper') : null;
  const swiperWrapper = swiperEl && swiperEl.querySelector('.swiper-wrapper');
  const paginationEl = swiperEl && swiperEl.querySelector('.swiper-pagination');
  let allSwiperSlides = null;
  let hiddenSlidesContainer = null;
  let prodPageSwiper = null;

  function updatePaginationVisibility() {
    if (!paginationEl || !prodPageSwiper) return;
    paginationEl.style.display = prodPageSwiper.slides.length > 1 ? '' : 'none';
  }

  function createProductSwiper() {
    if (prodPageSwiper || !swiperEl) return;
    prodPageSwiper = new Swiper(swiperEl, {
      loop: false,
      slidesPerView: 1,
      autoHeight: false,
      speed: 380,
      touchRatio: 1,
      touchAngle: 45,
      threshold: 5,
      resistance: true,
      resistanceRatio: 0.85,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        nextEl: swiperEl.querySelector('.swiper-btn--next'),
        prevEl: swiperEl.querySelector('.swiper-btn--prev'),
      },
      on: {
        init: function () { updatePaginationVisibility(); },
      },
    });
  }

  function initSwiperSlideCache() {
    if (!swiperWrapper || allSwiperSlides) return;
    allSwiperSlides = Array.from(swiperWrapper.querySelectorAll('.product__media-item.swiper-slide'));
    hiddenSlidesContainer = document.createElement('div');
    hiddenSlidesContainer.id = '_ctm-slides-hidden';
    hiddenSlidesContainer.style.cssText = 'display:none;position:absolute;left:-9999px;visibility:hidden';
    // Outside swiperEl — Swiper queries .swiper-slide inside its container element,
    // so slides here would pollute slidesGrid.
    swiperEl.parentNode.insertBefore(hiddenSlidesContainer, swiperEl.nextSibling);
  }

  function extractVariantParts(altText) {
    if (!altText) return [];
    const raw = altText.toLowerCase();
    const parts = raw.split('||').map((p) => p.trim());
    const matchSegment = parts.length > 1 ? parts[1] : parts[0];
    return matchSegment
      .replace('variants:', '')
      .split('*')
      .map((v) => v.trim())
      .filter(Boolean);
  }

  function matchesColor(mediaEl, colorValue) {
    const variantParts = extractVariantParts(mediaEl.getAttribute('data-media-alt') || '');
    return variantParts.some((part) => part.trim().toLowerCase() === colorValue.toLowerCase());
  }

  function updateMediaDisplay(e) {
    let defaultVariantValue;

    const checkedSwatch = Array.from(colorSwatches).find((input) => input.checked);
    if (!checkedSwatch) return;

    const modelSizingTest = checkedSwatch.dataset.modelSizing || '';

    if (e && e.target) {
      defaultVariantValue = e.target.value;
    } else {
      defaultVariantValue = checkedSwatch.getAttribute('data-variant-value');
    }

    if (!defaultVariantValue) return;

    // If no images are tagged for this color, show everything
    const hasAnyMatch = Array.from(mediaItems).some((m) => matchesColor(m, defaultVariantValue));
    const showAll = !hasAnyMatch;

    // --- Mobile swiper slides: physically move in/out of wrapper ---
    if (swiperWrapper) {
      initSwiperSlideCache();

      // Move all slides to hidden container first
      allSwiperSlides.forEach((slide) => hiddenSlidesContainer.appendChild(slide));

      // Move matching slides back in original order
      allSwiperSlides.forEach((slide) => {
        if (showAll || matchesColor(slide, defaultVariantValue)) {
          swiperWrapper.appendChild(slide);
        }
      });
    }

    // --- Thumbnails (sublist): display:none is fine here ---
    document.querySelectorAll('.product__media-subitem').forEach((media) => {
      media.style.display = (showAll || matchesColor(media, defaultVariantValue)) ? '' : 'none';
    });

    // --- Desktop grid items: display:none ---
    document.querySelectorAll('.product__media-item:not(.swiper-slide)').forEach((media) => {
      media.style.display = (showAll || matchesColor(media, defaultVariantValue)) ? '' : 'none';
    });

    // --- Model sizing badge (desktop grid) ---
    const visibleMediaItems = [...document.querySelectorAll('.product__media-item:not(.swiper-slide)')].filter(
      (el) => el.style.display != 'none'
    );

    visibleMediaItems.forEach((el, index) => {
      const badge = el.querySelector('div.product-color-badge');
      if (badge) badge.remove();

      if (modelSizingTest && modelSizingTest.trim() !== '') {
        if (isQuickView) {
          if (index == 0 || (visibleMediaItems.length == 1 && index == 0)) {
            el.insertAdjacentHTML('beforeend', `<div class="product-color-badge">${modelSizingTest}</div>`);
          }
        } else {
          if (index == 1 || (visibleMediaItems.length == 1 && index == 0)) {
            el.insertAdjacentHTML('beforeend', `<div class="product-color-badge">${modelSizingTest}</div>`);
          }
        }
      }
    });

    modelSizeTextEl.forEach((el) => {
      el.textContent = modelSizingTest;
    });

    updateVariantBadge();

    if (prodPageSwiper) {
      setTimeout(() => {
        prodPageSwiper.update();
        prodPageSwiper.pagination.render();
        prodPageSwiper.pagination.update();
        prodPageSwiper.slideTo(0, 0);
        updatePaginationVisibility();
      }, 50);
    }

    // --- Load more (desktop) ---
    const loadMoreBtn = document.getElementById('load-more-media');
    if (loadMoreBtn) {
      const allDesktopItems = Array.from(document.querySelectorAll('.product__media-item:not(.swiper-slide)'));
      const visibleDesktopItems = allDesktopItems.filter((el) => el.style.display !== 'none');

      allDesktopItems.forEach((el) => el.classList.remove('extra-product-media', 'hidden'));

      if (visibleDesktopItems.length > 4) {
        visibleDesktopItems.forEach((el, index) => {
          if (index >= 4) el.classList.add('extra-product-media', 'hidden');
        });
        loadMoreBtn.style.display = 'inline-block';
      } else {
        loadMoreBtn.style.display = 'none';
      }

      loadMoreBtn.onclick = function () {
        document.querySelectorAll('.extra-product-media').forEach((el) => el.classList.remove('hidden'));
        loadMoreBtn.style.display = 'none';
      };
    }

    // --- Shop This Color link ---
    if (_stcLink) {
      const stcUrl = _stcMap[defaultVariantValue.trim().toLowerCase()];
      const stcWrapper = _stcLink.closest('.ctm_shop_this_color');
      if (stcUrl) {
        _stcLink.href = stcUrl;
        if (stcWrapper) stcWrapper.style.display = '';
      } else {
        if (stcWrapper) stcWrapper.style.display = 'none';
      }
    }
  }

  // 1. Filter slides immediately (DOM manipulation, no Swiper needed)
  updateMediaDisplay();

  setTimeout(() => {
    if (window.innerWidth <= 767) {
      createProductSwiper();
    } else {
      const mm = window.matchMedia('(max-width: 767px)');
      const onMobile = (e) => {
        if (e.matches) {
          createProductSwiper();
          mm.removeEventListener('change', onMobile);
        }
      };
      mm.addEventListener('change', onMobile);
    }
  }, 0);

  colorSwatches.forEach((swatch) => {
    swatch.addEventListener('change', (e) => {
      updateMediaDisplay(e);
    });
  });

  function updateVariantBadge() {
    const checkedSwatch = Array.from(colorSwatches).find((input) => input.checked);

    if (!checkedSwatch) return;

    const modelSizingText = checkedSwatch.dataset.modelSizing;

    if (modelSizingText && modelSizingText.trim() !== '') {
      const badges = document.querySelectorAll('.product__media-item .product-color-badge.mobile');
      badges.forEach((badge) => {
        badge.textContent = modelSizingText;
        badge.style.display = 'block';
      });
    } else {
      const badges = document.querySelectorAll('.product__media-item .product-color-badge.mobile');
      badges.forEach((badge) => {
        badge.textContent = '';
        badge.style.display = 'none';
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  handleProductImages();
});

window.addEventListener("quickview:load", () => {
  handleProductImages(true);
});

$(document).ready(function () {
  function updateSelectedValue(target) {
    const selectedValue = $(target)
      .closest("div.swiper-slide-thumb-active")
      .find("img")
      .attr("alt");
    $(".size_model-content .main-text-model").text(selectedValue);
  }

  $(document).on("click", ".product__media-subitem", function (e) {
    updateSelectedValue(e.target);
  });

  $(document).on(
    "click",
    "variant-radios .product-form__controls-group .color-swatch",
    function (e) {
      setTimeout(() => {
        updateSelectedValue(".product__media-subitem");
      }, 100);
    }
  );

  $(document).on(
    "click",
    ".product__media-list .swiper-btn--next, .product__media-list .swiper-btn--prev",
    function (e) {
      const activeSlide = $(
        ".product__media-subitem.swiper-slide-thumb-active"
      );
      updateSelectedValue(activeSlide);
    }
  );

  const activeThumb = $(
    ".product__media-subitem.swiper-slide-thumb-active img"
  );
  if (activeThumb.length) {
    updateSelectedValue(activeThumb);
  }

  $(document).on(
    "click",
    ".product-form__controls-group .color-swatch:not([data-cross-sell-list] *)",
    function (e) {
      $(".product__media-list .swiper-wrapper").css(
        "transform",
        "translate3d(0px, 0px, 0px)"
      );
    }
  );

  $(document).on(
    "click",
    ".product__media-sublist .swiper-wrapper .product__media-subitem",
    function (e) {
      const index = $(this).index();
      const itemWidth = $(".product__media-item").outerWidth();
      const translateValue = -(itemWidth * index);
      $(".product__media-list .swiper-wrapper").css(
        "transform",
        `translate3d(${translateValue}px, 0px, 0px)`
      );
    }
  );
});

// Product tag js update
document.addEventListener("DOMContentLoaded", function () {
  const tagEl = document.querySelector("#variant-tag");

  if (!tagEl) return;

  const swatchInputs = document.querySelectorAll(".color-swatch-input:not([data-cross-sell-list] *)");

  function updateTagFromSelectedInput() {
    const selectedInput = document.querySelector(".color-swatch-input:checked:not([data-cross-sell-list] *)");
    const tagValue = selectedInput?.dataset.tag || "";
    tagEl.textContent = tagValue;
    tagEl.closest(".product-variant--tag").style.display = tagValue ? "block" : "none";
  }

  updateTagFromSelectedInput();

  swatchInputs.forEach(input => {
    input.addEventListener("change", updateTagFromSelectedInput);
  });
});

